<template>
    <div class="fhv-centent" >
        <h4 class="title-topic">Wi-Fi Repeater</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
            :model="wifiRelayFrom" 
            label-position="left" 
            :rules="isChecked.wifiRelay" 
            ref="wifiRelayFrom" 
            class="fhv-form" 
            size="mini"
            label-width="180px" 
            :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
            v-loading="getLoad"
        >
            <el-form-item label="Repeater Enable">
                <el-switch v-model="wifiRelayFrom.wifiRelayEnable" @change="changeWlRelayEnable"></el-switch>
            </el-form-item>
            <div v-if="wifiRelayFrom.wifiRelayEnable">
                <p class="fh-choose" 
                v-if="wifiRelayFrom.ssidName != ''" 
                @click="wifiRelayFrom.isShowWIiFiSelect = true">
                Reselect</p>
                <el-form-item label="Wi-Fi Name" prop="ssidName">
                    <el-input type="text" 
                        v-model="wifiRelayFrom.ssidName" 
                        auto-complete="off" 
                        @click.native="wifiRelayInputClick"
                        placeholder="Please select an available network" 
                        ></el-input>
                </el-form-item>
                <el-form-item label="Encryption Mode" v-if="wifiRelayFrom.encryptionMode == 'OPEN'" prop="encryptionMode">
                    <el-select v-model="wifiRelayFrom.encryptionMode" placeholder="Please select the encryption mode" class="fh-form-select" disabled>
                        <el-option label="OPEN" value="OPEN"></el-option>
                        <el-option label="WEP" value="WEP"></el-option>
                        <el-option label="WPA-PSK/WPA2-PSK" value="WPA-PSK/WPA2-PSK"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Wi-Fi Password" prop="ssidPassword" v-if="wifiRelayFrom.encryptionMode != 'OPEN'">
                    <el-input placeholder="Please enter the Wi-Fi password" :type="wifiRelayFrom.isShowPassword ?  'text' : 'password'" v-model="wifiRelayFrom.ssidPassword" auto-complete="new-password" >
                        <i slot="suffix" 
                            class="el-input__icon glyphicon  fhv-password" 
                            :class="[wifiRelayFrom.isShowPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                            @click="wifiRelayFrom.isShowPassword = !wifiRelayFrom.isShowPassword">
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item label="Synchronize">
                    <el-tooltip  effect="dark" 
                    popper-class="item"
                    placement="right">
                        <div slot="content">After connection, the Wi-Fi name and Wi-Fi password of the local router will be the same as those of the main router (recommended)</div>
                        <el-switch v-model="wifiRelayFrom.syncEnable"></el-switch>
                    </el-tooltip>   
                </el-form-item>
                <el-form-item class="fh-form-btn">
                    <el-button type="primary" @click="connectClick" class="btn">Connect Network</el-button>
                </el-form-item>
            </div>
        </el-form>
        <!-- 无线中继WIFI弹出层 -->
        <el-dialog :visible.sync="wifiRelayFrom.isShowWIiFiSelect" :show-close="false" width="500px" class="fh-dialog">
            <h3 slot="title">Please select an available network</h3>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="wifiRelayFrom.isShowWIiFiSelect = false">cancel</el-button>
                <el-button type="primary" @click="wifiRelaySearch">Rescan</el-button>
            </div>
            <div class="fh_layer_content" v-loading.lock="wifiRelayFrom.loading">
                <div class="fh-no-wifi"  v-if="wifiRelayFrom.isSearch && !wifiRelayFrom.wifiRelaySearchList.length">
                    <div class="step_center_img">
                        <img src="@/assets/img/basic/pic_search_nowifi.png">
                    </div>
                    <div class="step_center_des">
                        <h2>No Wi-Fi available for search</h2>
                        <p class="no_lan_des">Please check this Wi-Fi is available nearby and rescan</p>
                    </div>
                </div>
                <table class="fh_search_wifi_table" v-else>
                    <tr v-for="(ssid, index) in wifiRelayFrom.wifiRelaySearchList" 
                    :key="ssid.bssid"
                    @click="wifiRelayListClick(index,'wifiRelayFrom')">
                        <td class="fh_search_result_table_main">
                            <div class="fh_search_result_table_head">{{ssid.ssidName}}</div>
                            <div class="fh_search_result_table_body">{{ssid.encrypt}}</div>
                        </td>
                        <td class="fh_search_wifisignal">
                            <div :class="wlSignalStrength(index)"></div>
                        </td>
                    </tr>
                </table>
                
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import devConfig from '@/devConfig'
    export default {
        data () {
            return {
                getLoad:false,
                wl1Enable:false,
                wl0Enable:false,
                wifiRelayFrom:{
                    wifiRelayEnable:false,
                    ssidName:"",
                    ssidPassword:"",
                    encryptionMode:"",
                    bssid:'',
                    wlIndex:'',
                    syncEnable:true,
                    isShowPassword:false,
                    isShowWIiFiSelect:false,
                    loading:false,
                    isSearch:false,
                    wifiRelaySearchList:[]
                },
                isChecked : {
                    wifiRelay:{
                        ssidName:[
                            { required: true, message: 'Please select an available network', trigger: 'blur' },
                        ],
                        ssidPassword:[
                            { required: true, message: 'Incorrect password input', trigger: 'blur' },
                            { min: 8, max: 64, message: '8 to 32 characters in length', trigger: 'blur' }
                        ],
                        encryptionMode:[
                            { required: true, message: 'Please choose an encryption method', trigger: 'blur' }
                        ]
                    }
                },
            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            // 初始化获取 Repeat enable 开关 状态
            getData:function(){
                this.getLoad = true
                axios.post('/boafrm/fhWLRelayJSON',{CmdType:"GET_WLRELAY"})
                .then( (response) => {
                    this.getLoad = false
                    if(response.data.ret === 0)
                    {
                        this.wl1Enable = response.data.wl1Enable;
                        this.wl0Enable = response.data.wl0Enable;
                        this.wifiRelayFrom.wifiRelayEnable = response.data.rptr_enabled;
                    }
                    else
                    {
                        this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
                    }
                })
                .catch((error) => {
                    this.getLoad = false
                    this.$message.error('GET data failed! Network connection error!')
                })
            },
            // Repeat enable 开关操作
            changeWlRelayEnable(val){
                if(val && !this.wl1Enable && !this.wl0Enable)
                {
                    this.$alert('The device wireless switch is turned off and the relay network cannot be opened!', 'Repeat enable', {
                        type:'warning'
                    })
                    this.wifiRelayFrom.wifiRelayEnable = !val;
                    return;
                }

                const loadingInstance = this.$loading({lock: true})
                axios.post('/boafrm/fhWLRelayJSON',
                {
                    CmdType:"SET_WLRELAY",
                    wlRelaySwitch:this.wifiRelayFrom.wifiRelayEnable
                })
                .then((response) => {
                    if(response.data.ret === 0)
                    {   
                        // 更新全局 桥模式状态
                        this.$G_DEVICE_CFG.isBridge = val
                        devConfig.update(this.$G_DEVICE_CFG)
                        // 关闭中继时,由于可能需要重新获取地址，所以延后25s显示成功
                        setTimeout(() => {
                            loadingInstance.close()
                            this.$message.success('Set Repeat enable Success!');
                        },25000)
                    }
                    else
                    {
                        loadingInstance.close()
                        this.wifiRelayFrom.wifiRelayEnable = !val;
                        this.$message.error(`Set Repeat enable failed! Error:${response.data.errMsg}`)
                    }
                })
                .catch((error) => {
                    loadingInstance.close()
                    this.wifiRelayFrom.wifiRelayEnable = !val;
                    this.$message.error('Set Repeat enable failed! Network connection error!')
                })
            },
            //点击输入框选择中继处理
            wifiRelayInputClick () {
                if(!this.wl1Enable && !this.wl0Enable)
                {
                    this.$alert('The device wireless switch is turned off and you cannot search the relay network!', 'Search', {
                        type:'warning'
                    })
                    return;
                }
                this.wifiRelayFrom.isShowWIiFiSelect = true;
                if(this.wifiRelayFrom.wifiRelaySearchList.length == 0)
                    this.wifiRelaySearch();
            },
            wifiRelaySearch () {
                let _wlIndex = 1;
                if(this.wl1Enable && this.wl0Enable)
                {// 2.4G and 5G
                    _wlIndex = 2;
                }
                else if(this.wl1Enable)
                {// only 2.4G
                    _wlIndex = 1;
                }
                else if(this.wl0Enable)
                {// only 5G
                    _wlIndex = 0;
                }
                let wllsits = [];
                this.wifiRelayFrom.loading = true;
                this.wifiRelayFrom.wifiRelaySearchList = [];
                this.wifiRelayFrom.isSearch = false;
                axios.post('/boafrm/fhWLRelayJSON',
                {
                    CmdType:"GET_WLRELAY_SEARCH",
                    wlIndex:_wlIndex
                })
                .then( (response) => {
                    if(response.data.ret === 0)
                    {
                        if(_wlIndex != 2)
                        {
                            wllsits = response.data.wlRelayLists;
                        }
                        else
                        {
                            wllsits = wllsits.concat(
                                response.data.wl1RelayLists,
                                response.data.wl0RelayLists
                            )
                            wllsits.sort(function (v1,v2) {
                                return v2.strength - v1.strength
                            })
                        }
                    }
                    this.wifiRelayFrom.wifiRelaySearchList = wllsits;
                    this.wifiRelayFrom.loading = false;
                    this.wifiRelayFrom.isSearch = true;
                })
                .catch((error) => {
                    this.wifiRelayFrom.loading = false;
                    this.wifiRelayFrom.isSearch = true;
                    this.wifiRelayFrom.isShowWIiFiSelect = false
                    this.$alert('The device management IP address has changed, please use the new management IP to visit, or try to refresh the web page.', 'Warning ', {
                        confirmButtonText: 'Try Refresh',
                        showClose: false,
                        type: 'warning',
                        callback: action => {
                            window.location.href = 'http://192.168.1.1'
                        }
                    });
                })
            },
            //中继选择wifi之后处理
            wifiRelayListClick(index,formName) {
                this.wifiRelayFrom.ssidName = this.wifiRelayFrom.wifiRelaySearchList[index].ssidName;
                this.wifiRelayFrom.isShowWIiFiSelect = false;
                this.wifiRelayFrom.encryptionMode = this.wifiRelayFrom.wifiRelaySearchList[index].encrypt;
                this.wifiRelayFrom.bssid = this.wifiRelayFrom.wifiRelaySearchList[index].bssid;
                this.wifiRelayFrom.wlIndex = this.wifiRelayFrom.wifiRelaySearchList[index].wlIndex;
                this.wifiRelayFrom.ssidPassword = "";
                this.$refs[formName].clearValidate();
            },
            //计算信号强度显示class  
            wlSignalStrength(index) {   
                var sifnalClass = "wifisignal_encrypt_strong";
                var sifnalNum = this.wifiRelayFrom.wifiRelaySearchList[index].strength;
                if(sifnalNum <= 30)
                {
                    sifnalClass = "wifisignal_encrypt_weak";
                }
                else if(sifnalNum > 30 && sifnalNum <= 60)
                {
                    sifnalClass = "wifisignal_encrypt_normal";
                }
                else
                {
                    sifnalClass = "wifisignal_encrypt_strong";
                }
                return sifnalClass;
            },
            // 中继连接按钮
            connectClick(){
                this.$refs['wifiRelayFrom'].validate((valid) => {
                    if (valid) {
                        this.connectData();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 提交中继连接数据
            connectData(){
                const loadingInstance = this.$loading({lock: true})
                axios.post('/boafrm/fhWLRelayJSON',
                {
                    CmdType:"WLRELAY_CONNECT",
                    bssid:this.wifiRelayFrom.bssid,
                    encrypt:this.wifiRelayFrom.encryptionMode,
                    pskval:this.wifiRelayFrom.ssidPassword,
                    syncEnable:this.wifiRelayFrom.syncEnable,
                    wlIndex:this.wifiRelayFrom.wlIndex
                })
                .then((response) => {
                    
                    if(response.data.ret === 0)
                    {
                        //连接中继网络,由于可能需要重新获取地址，所以延后20s显示成功
                        setTimeout(() => {
                            loadingInstance.close()
                            this.$message.success('Repeat Connect Success!');
                        },20000)
                        
                    }
                    else
                    {
                        loadingInstance.close()
                        this.$message.error(`Repeat Connect Failed! Error:${response.data.errMsg}`)
                    }
                })
                .catch((error) => {
                    loadingInstance.close()
                    this.$alert(
                        'Repeat Connect Success!The device management IP address has changed, please use the new management IP to visit, or try to refresh the web page.', 
                        'Warning', 
                        {
                            confirmButtonText: 'Try Refresh',
                            type: 'warning',
                            showClose: false,
                            callback: action => {
                                window.location.href = 'http://192.168.1.1'
                            }
                    })
                })
            }
        }
    }
</script>

<style src="@/assets/style/wlRepeate.css"></style>